import React from 'react';
import GenericSearchForm from '../GenericSearch/GenericSearchForm';

const UnitsSearchForm = (props) => {
  const fields = [
    {
      id: 'units_search_form_customer_field',
      key: 'customer',
      label: 'Customer (Name or Email)',
      placeholder: 'Customer name or email',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 3, xl: 2 }
    },
    {
      id: 'units_search_form_phone_number_field',
      key: 'phone_number',
      label: 'Phone number',
      placeholder: 'Phone number',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      id: 'units_search_form_unit_number_field',
      key: 'unit_number',
      label: 'Unit #',
      placeholder: 'Unit#',
      type: 'text',
      gridProps: { xs: 12, sm: 3, lg: 2, xl: 2 }
    },
    {
      id: 'units_search_form_license_plate_field',
      key: 'license_plate',
      label: 'License Plate (LP)',
      placeholder: 'License Plate(LP)',
      type: 'text',
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    },
    {
      id: 'units_search_form_status_field',
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { id:'all', value: '', label: 'All' },
        { id:'active', value: 'active', label: 'Active' },
        { id:'blocked', value: 'blocked', label: 'Blocked' },
        { id:'suspended', value: 'suspended', label: 'Suspended' },
        { id:'pending', value: 'pending', label: 'Pending' },
        { id:'archived', value: 'archived', label: 'Archived' }
      ],
      gridProps: { xs: 12, sm: 4, lg: 2, xl: 2 }
    }
  ];

  return <GenericSearchForm {...props} fields={fields} />;
};

export default UnitsSearchForm;